var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4 27.6c4.327 4.328 13.028 2.642 19.435-3.765C30.242 17.428 31.928 8.727 27.6 4.4 23.275.071 14.573 1.757 8.166 8.164 1.758 14.572.072 23.274 4.4 27.6zm5.717-5.821c1.529 1.528 5.379.156 8.6-3.064 3.22-3.22 4.59-7.07 3.062-8.6-1.53-1.528-5.38-.157-8.6 3.063-3.22 3.22-4.592 7.07-3.063 8.599z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEps);
export default __webpack_public_path__ + "static/media/EPS.81ed5d84c058b8b7b8c08b3f60ed3b43.svg";
export { ForwardRef as ReactComponent };